import styled from "styled-components";

export const HeaderWrapper = styled.header`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.secundaria};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15px;

  img {
    max-height: 200px;
    @media only screen and (max-width: 500px) {
      max-height: none;
      max-width: 80%;
    }
  }
`;

export const HeaderTitle = styled.section`
  position: relative;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 15px;
  background-color: ${({ theme }) => theme.colors.primaria};

  span {
    display: block;
    font-weight: bold;
    width: fit-content;
    font-size: 20px;
    text-transform: uppercase;
    margin: 0 auto;
    color: ${({ theme }) => theme.colors.background};
  }

  button {
    position: absolute;
    padding: 5px 14px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.background};
    right: 8px;
    top: 6px;
    transition-duration: 0.4s;

    &:hover {
      background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      color: ${({ theme }) => theme.colors.primaria};
    }
  }

  @media only screen and (max-width: 700px) {
    padding-right: 60px;
    text-align: center;
  }
`;
